import type { NodeDefinition } from './nodeDefinition';

export enum WorkspaceModelOrigin {
  System = 'system',
  UserRequest = 'user_request',
}

export enum WorkspaceModelStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export type ModelDefinition = Pick<NodeDefinition, 'id' | 'createdAt'> & {
  name: string;
  displayName: string;
  description: string;
  icon: string;
  isNew: boolean;
  isAllowed?: boolean;
  modelId: string;
  isVerified: boolean;
  termsUrls?: string[];
  privacyPolicyUrl?: string;
  origin?: WorkspaceModelOrigin;
  status?: WorkspaceModelStatus | null;
  requesterEmail?: string;
  requestedAt?: string;
  reviewerName?: string;
  decidedAt?: string;
  modelSourceUrl?: string;
  providerId?: string;
};
